/* eslint-disable */
import React from 'react';
import { ReferenceField, TextField, useTranslate } from 'react-admin';
import { NumberField } from '../../../../base/components/ra/fields';
import resourceSlug, { REPORT_TYPES } from '../../../../constant/resource-slug';
import { LIST_REPORTS } from '../../report-performance.list';
import CustomReportTable from '../../../../base/components/reports/CustomReportTable';
import BaseCurrencyField from '../../../../base/components/reports/ReportTable/BaseCurrencyField';
import { useReportContext } from '../../../../base/components/reports/ReportLayout';
import CustomLinkField from '../../../../base/components/ra/fields/customLink.field';
import { transformIdValue } from '../../../../services/util/stringUtil';
import { ID_EMPTY } from '../../../../constant';
import { GROUP_BY_OPTIONS } from '../PerformanceReportFilters/GroupByCheckbox';
import TranslatableField from '../../../../base/components/ra/fields/translatable.field';

const PrepaidTable = () => {
  const translate = useTranslate();
  const { appliedFilters } = useReportContext();

  const hasNotCurrencyInfo = appliedFilters.groupBy?.length > 0 && !Boolean(appliedFilters.consolidated)

  return (
    <CustomReportTable
      title={translate('resources.report.prepaid')}
      reportType={REPORT_TYPES.PREPAID}
      reportList={LIST_REPORTS}
      resource={resourceSlug.REPORT_PERFORMANCE}
    >
      <CustomLinkField
        sortable={false}
        source="id"
        href={(record) => `/#/${resourceSlug.BET}/${record.id}/show`}
        title={(record) => (record.id ? transformIdValue(record.id) : ID_EMPTY)}
      />
      {appliedFilters.groupBy?.includes(GROUP_BY_OPTIONS.DATE) && (
        <TextField source="date" label="resources.report.fields.date" sortable />
      )}
      {appliedFilters.groupBy?.includes(GROUP_BY_OPTIONS.GROUP) && (
        <ReferenceField link="show" source="group" reference="group" label="resources.group.name">
          <TextField source="name" />
        </ReferenceField>
      )}
      {appliedFilters.groupBy?.includes(GROUP_BY_OPTIONS.BRAND) && (
        <ReferenceField link="show" source="brand" reference="brand" label="resources.brand.name">
          <TextField source="name" />
        </ReferenceField>
      )}
      {appliedFilters.groupBy?.includes(GROUP_BY_OPTIONS.GAME) && (
        <TranslatableField label="resources.report.fields.gameName" source="game" />
      )}
      {appliedFilters.groupBy?.includes(GROUP_BY_OPTIONS.GAME_TYPE) && (
        <TextField label="resources.report.fields.gameType" source="gameType" sortable={false} />
      )}
      {appliedFilters.groupBy?.includes(GROUP_BY_OPTIONS.BET_TYPE) && (
        <TextField label="resources.report.fields.betType" source="betType" sortable={false} />
      )}
      {appliedFilters.groupBy?.includes(GROUP_BY_OPTIONS.MONTH) && (
        <TextField source="month" label="resources.report.fields.month" sortable />
      )}
      <NumberField label="resources.report.fields.playerCount" source="playerCount" sortable={false} />
      <TextField label="resources.report.fields.betAmount" source="betAmount" sortable />
      <TextField label="resources.report.fields.wonAmount" source="wonAmount" sortable />
      <NumberField label="resources.report.fields.betCount" source="betCount" sortable />
      {hasNotCurrencyInfo ? null : (
          <TextField label="resources.report.fields.currencyType" source="currencyType" sortable={false} />
          
      )}
      {hasNotCurrencyInfo ? null : <ReferenceField link="show" source="currency" reference="currency" label="resources.currency.name">
            <TextField source="code" />
          </ReferenceField>}
      {Boolean(appliedFilters.consolidated) && <BaseCurrencyField label="resources.report.fields.baseCurrency" />}
    </CustomReportTable>
  );
};

export default PrepaidTable;
